<template>
  <v-card content--fluid tile flat>
    <v-tabs
      v-model="tab"
      background-color="grey lighten-4"
      aria-selected="primary"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        href="#/jurisprudencia/todas-bases"
        @click="routerLink('/jurisprudencia/todas-bases')"
      >
        <span class="font-weight-regular">todas as bases</span>
      </v-tab>
      <v-tab
        href="#/jurisprudencia/selecionada"
        @click="routerLink('/jurisprudencia/selecionada')"
      >
        <span class="font-weight-regular">Jurisprudência selecionada</span>
      </v-tab>
      <v-tab
        href="#/jurisprudencia/inteiro-teor"
        @click="routerLink('/jurisprudencia/inteiro-teor')"
      >
        <span class="font-weight-regular">inteiro teor</span>
      </v-tab>
      <v-tab
        href="#/jurisprudencia/boletim"
        @click="routerLink('/jurisprudencia/boletim')"
      >
        <span class="font-weight-regular">boletins</span>
      </v-tab>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            class="font-weight-regular align-self-center mr-4"
            style="color: #817e7c"
            v-bind="attrs"
            v-on="on"
            @click="routerSinj()"
          >
            súmulas
          </v-btn>
        </template>
      </v-menu>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <!-- ABA DE JURISPRUDENCIA TODA BASE -->
      <v-tab-item value="/jurisprudencia/todas-bases">
        <toda-base
          :historicoTodaBase="historicoJurisprudencia.historicoTodaBase"
          :routerTerm="paramsHref"
        />
      </v-tab-item>

      <!-- ABA DE JURISPRUDENCIA SELECIOANDA -->
      <v-tab-item value="/jurisprudencia/selecionada">
        <selecionada
          :historicoSelecionada="historicoJurisprudencia.historicoSelecionada"
          :routerTerm="paramsHref"
        />
      </v-tab-item>

      <!-- ABA DE JURISPRUDENCIA INTEIRO TEOR -->
      <v-tab-item value="/jurisprudencia/inteiro-teor">
        <inteiro-teor
          :historicoInteiroTeor="historicoJurisprudencia.historicoInteiroTeor"
          :routerTerm="paramsHref"
        />
      </v-tab-item>

      <!-- ABA DE JURISPRUDENCIA BOLETINS -->
      <v-tab-item value="/jurisprudencia/boletim">
        <boletim
          :historicoBoletim="historicoJurisprudencia.historicoBoletim"
          :routerTerm="paramsHref"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import TodaBase from "@/components/jurisprudencia/TodaBase";
import InteiroTeor from "@/components/jurisprudencia/InteiroTeor";
import Selecionada from "@/components/jurisprudencia/Selecionada";
import Boletim from "@/components/jurisprudencia/Boletim";

export default {
  props: {
    historicoJurisprudencia: {},
    paramsJurisprudencia: Array,
    tabJurisp: null,
    paramsHref: {}
  },
  components: {
    TodaBase,
    InteiroTeor,
    Selecionada,
    Boletim
  },
  data() {
    return {
      tab: this.tabJurisp,
      termo: ""
    };
  },
  methods: {
    routerLink(route) {
      window.location = `#${route}`;
      this.$emit("redirectRoute", route);
    },
    routerSinj() {
      window.open(
        "https://www.sinj.df.gov.br/sinj/ResultadoDePesquisa?tipo_pesquisa=norma&all=&ch_tipo_norma=76000000&nm_tipo_norma=S%C3%BAmula&nr_norma=&ano_assinatura=&ch_orgao=613&ch_hierarquia=613&sg_hierarquia_nm_vigencia=TCDF+-+Tribunal+de+Contas+do+Distrito+Federal+%281960-%29&origem_por=toda_a_hierarquia_em_qualquer_epoca1",
        "_blank"
      );
    }
  }
};
</script>
